import { render, staticRenderFns } from "./YearlyChart.vue?vue&type=template&id=4c5efbe4&"
import script from "./YearlyChart.vue?vue&type=script&lang=ts&"
export * from "./YearlyChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports